/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './Avatar.style';

import BaseIcon from 'src/shared/ui/component/icon/BaseIcon';
import {
  xsmall,
  small,
  medium,
  large,
  xlarge,
  xxlarge,
} from './setting/avatarVariants';

import svg from './default-avatar.svg';

import type { AvatarProps } from './type/avatarTypes';

type Props = AvatarProps;

const useStyles = createUseStyles(styles);

const DefaultAvatar = ({ layoutClass, variant, alt }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  const rootClasses = classNames(classes.root, layoutClass, {
    [classes['root-xsmall']]: variant === xsmall,
    [classes['root-small']]: variant === small,
    [classes['root-medium']]: variant === medium,
    [classes['root-large']]: variant === large,
    [classes['root-xlarge']]: variant === xlarge,
    [classes['root-xxlarge']]: variant === xxlarge,
  });

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return <BaseIcon className={rootClasses} svg={svg} title={alt} />;
};

// Make variants available
export * from './setting/avatarVariants';

export default compose(React.memo)(DefaultAvatar);
